// extracted by mini-css-extract-plugin
export default {"background":"cover_background__UkvZP","img":"cover_img__FvAnc"};